import React from 'react';
import { bool, func, string } from 'prop-types';
import classnames from 'classnames';
import { noop } from 'utils';
import { Close } from 'components/Icons';
import './Chip.scss';

const Chip = ({
    active,
    extraClassName,
    deletable,
    label,
    imageUrl,
    onClick,
    url,
}) => {
    if (label === '') return null;
    const chipCn = classnames(
        'chip',
        { 'chip--active': active },
        { deletable },
        { [extraClassName]: extraClassName },
    );

    return (
        <a href={url} className={chipCn} onClick={onClick}>
            {imageUrl !== '' && (
                <img src={imageUrl} alt={label} className="chip__thumb" />
            )}
            <span className="chip__label">{label}</span>
            {deletable && (
                <div
                    className="chip__delete-button"
                    data-button={`deleteChipButton:${label}`}
                >
                    <Close
                        className="chip__delete-button__icon"
                        width="8"
                        height="8"
                    />
                </div>
            )}
        </a>
    );
};

Chip.propTypes = {
    active: bool,
    extraClassName: string,
    deletable: bool,
    label: string.isRequired,
    imageUrl: string,
    onClick: func,
    url: string,
};

Chip.defaultProps = {
    active: false,
    extraClassName: undefined,
    deletable: false,
    imageUrl: '',
    onClick: noop,
    url: undefined,
};

Chip.displayName = 'Chip';

export default Chip;
